import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { API } from "../../api";
import config from "../../config";
import { MOCK_DASHBOARD_LIST } from "../../constants";
import { store } from "../../store/store";
import { GetList } from "../MockData";
import { showLoader } from "../reducer/commonReducer";

export interface RoleState {
  workshopData: any;
  totalCount: number;
  status: "idle" | "loading" | "failed";
}
const initialState: RoleState = {
  workshopData: [],
  totalCount: 0,
  status: "idle",
};

export const workshopDataListAsync = createAsyncThunk(
  "dashboard/workshopDataList",
  async (request: any) => {
    store.dispatch(showLoader({ isLoader: true }));
    const result:any = await API.Post(
      `${config.BASE_URL}/Dashboard/GetWorkshopData`,
      {
        ...request,
      }
    );
    if (result)
    {
      store.dispatch(showLoader({ isLoader: false }));
}

    return result;
  }
);

export const workshopDataSlice:any = createSlice({
  name: "workshopReducer",
  initialState,
  reducers: {
    addData: (state, action: PayloadAction<any>) => {
      return { ...state, [action.payload.key]: action.payload.value };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(workshopDataListAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(workshopDataListAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.workshopData = action.payload;
      })
      .addCase(workshopDataListAsync.rejected, (state) => {
        state.status = "failed";
        state.workshopData = [];
      });
  },
});
export const {addData} =workshopDataSlice.actions
export default workshopDataSlice.reducer;
